import React from "react";
import styled from 'styled-components';

const Container = styled.div`
  margin-top: 110px;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  @media(max-width: 768px) {
    margin-top: 0;
    max-width: calc(100vw - 2rem);
  }
`

const Youtube = ({ embedId }) => (
  <Container>
    <div className="video-responsive">
      <iframe
        width="853"
        height="480"
        src={`https://www.youtube.com/embed/${embedId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  </Container>
);

export default Youtube;
